import { Download, ArrowRightLeft } from "lucide-react";

const th = "px-4 py-2 font-bold text-zinc-600 uppercase text-xs tracking-wider";
const monthLabel = (m) => (m ? new Date(`${m}-01T00:00:00`).toLocaleDateString("en-NZ", { month: "short", year: "numeric" }) : "—");

export const TransferReport = ({ data, onExport }) => (
  <div className="bg-white border border-zinc-200 rounded-lg shadow-[0_4px_16px_rgba(0,0,0,0.08)] mt-6 overflow-x-auto" data-testid="hire-transfers">
    <div className="px-4 py-3 border-b border-zinc-200 bg-zinc-50 flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <ArrowRightLeft size={16} className="text-violet-600" />
        <h3 className="font-heading text-lg font-bold tracking-tight text-zinc-900">Branch Transfers by Month</h3>
        <span className="text-xs text-zinc-500">{data.items.length} transfer{data.items.length === 1 ? "" : "s"}</span>
      </div>
      <button onClick={onExport} data-testid="export-transfers-button"
        className="text-xs font-bold text-zinc-700 hover:text-brand flex items-center gap-1.5 border border-zinc-300 rounded-full px-3 py-1.5 bg-white">
        <Download size={14} /> Export CSV
      </button>
    </div>
    {data.items.length === 0 ? (
      <p className="px-4 py-6 text-center text-sm text-zinc-400">No branch transfers match these filters.</p>
    ) : (
      <div className="grid lg:grid-cols-[2fr_3fr] divide-y lg:divide-y-0 lg:divide-x divide-zinc-200">
        <table className="w-full text-sm" data-testid="transfer-routes">
          <thead><tr className="border-b border-zinc-200 text-left"><th className={th}>Month</th><th className={th}>Route</th><th className={`${th} text-right`}>Transfers</th><th className={`${th} text-right`}>Units</th></tr></thead>
          <tbody className="divide-y divide-zinc-100">
            {data.routes.map((r) => (
              <tr key={`${r.month}-${r.from}-${r.to}`} data-testid={`transfer-route-${r.month}-${r.to}`}>
                <td className="px-4 py-2 font-semibold whitespace-nowrap">{monthLabel(r.month)}</td>
                <td className="px-4 py-2 text-zinc-700">{r.from} <span className="text-violet-600 font-bold">→</span> {r.to}</td>
                <td className="px-4 py-2 text-right tabular-nums font-bold">{r.transfers}</td>
                <td className="px-4 py-2 text-right tabular-nums">{r.units}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="max-h-[420px] overflow-y-auto">
          <table className="w-full text-sm" data-testid="transfer-items">
            <thead className="sticky top-0 bg-white"><tr className="border-b border-zinc-200 text-left"><th className={th}>Equipment</th><th className={th}>Route</th><th className={th}>Dates</th><th className={th}>Status</th></tr></thead>
            <tbody className="divide-y divide-zinc-100">
              {data.items.map((i) => (
                <tr key={i.id} data-testid={`transfer-item-${i.id}`}>
                  <td className="px-4 py-2 font-semibold">{i.equipment_name} <span className="text-zinc-400 font-normal">×{i.quantity}</span></td>
                  <td className="px-4 py-2 text-zinc-700 text-xs">{i.from} → {i.to}</td>
                  <td className="px-4 py-2 text-xs text-zinc-600 whitespace-nowrap">{i.start_date} → {i.end_date}</td>
                  <td className="px-4 py-2 text-xs uppercase font-bold text-zinc-500">{i.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </div>
);
